import React, { useState, useRef, useEffect } from "react";
import Sidebarmenu from "../../Sidebar/Sidebarmenu";
import Header from "../Header/Header";
import { user_management, fmb_schedule_url, user_catera } from "../../../Redux/Reducer/AuthReducer";
import { toast } from "react-toastify";
import loadergif from "../../../img/landing/loader123.gif";
import { getHijriParts } from "../../HijriCalendar/getHijriDate";
import "../Dashboard.css";

function convertDateForIos(dateStr) {
  if (!dateStr) return new Date();
  return new Date(dateStr.replace(/-/g, "/"));
}

// Short beep (~150ms, 1kHz), pre-encoded as a WAV data URI so playing it is
// just HTMLAudioElement.play() on an already-loaded clip - no AudioContext
// construction at scan time, which previously stalled alongside the camera stream.
const SCAN_BEEP_DATA_URI =
  "data:audio/wav;base64,UklGRtQEAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YbAEAADk5OTk5BwcHBzk5OTkHBwcHOTk5OQdHR0d4+Pj4x0dHR3j4+PjHR0dHePj4+MdHR0d4+Pj4x0dHR3j4+PjHh4eHuLi4h4eHh4e4uLi4h4eHh7i4uIeHh4eHuLi4uIeHh4e4uLiHx8fHx/h4eHhHx8fH+Hh4R8fHx8f4eHh4R8fHx/h4eHhHx8f4eHh4eEgICAg4ODg4CAgICDg4ODgICAgIODg4OAgICDg4ODg4CAgICDg4ODgISEhId/f398hISEh39/f3yEhId/f39/fISEhId/f398hISEh39/f3yIiIiLe3t7eIiIi3t7e3t4iIiIi3t7e3iIiIiLe3t7eIiIiIt7e3t4jIyMj3d3d3SMjI93d3d3dIyMjI93d3d0jIyMj3d3d3SMjIyPd3d3dJCQkJNzc3NwkJCQk3Nzc3CQkJCTc3NzcJCQkJNzc3CQkJCTc3Nzc3CUlJSXb29vbJSUlJdvb29slJSUl29vb2yUlJSXb29vbJSUlJdvb29smJiYm2tra2iYmJiba2traJiYm2tra2tomJiYm2tra2iYmJiba2traJycnJ9nZ2dknJycn2dnZ2ScnJyfZ2dnZJycnJ9nZ2dknJycn2dnZ2SgoKNjY2NjYKCgoKNjY2NgoKCgo2NjY2CgoKCjY2NjYKCgoKNjY2NgpKSkp19fX1ykpKSnX19fXKSkpKdfX19cpKSkp19fX1ykpKSnX19fXKioq1tbW1ioqKioq1tbW1ioqKirW1tbWKioqKtbW1tYqKioq1tbW1isrKyvV1dXVKysrK9XV1dUrKysr1dXV1SsrKyvV1dXVKysrK9XV1dUsLCws1NTU1CwsLCzU1NTULCwsLNTU1NQsLCws1NTU1CwsLCzU1NTULS0t09PT0y0tLS3T09PT0y0tLS3T09PTLS0tLdPT09MtLS0t09PT0y4uLi7S0tLSLi4uLtLS0tIuLi4u0tLS0i4uLi7S0tLSLi4uLtLS0tIvLy8v0dHR0S8vLy/R0dHRLy8vL9HR0dEvLy8v0dHR0S8vLy/R0dHRMDAwMNDQ0NAwMDAw0NDQMDAwMNDQ0NDQMDAwMNDQ0NAwMDAw0NDQ0DExMTHPz8/PMTExMc/Pz88xMTExz8/PzzExMTHPz8/PMTExMc/Pz88yMjIyzs7OzjIyMjLOzs7OMjIyMs7Ozs4yMjIyzs7OzjIyMjLOzs7OMzMzM83Nzc0zMzMzzc3NzTMzMzPNzc0zMzMzzc3Nzc0zMzMzzc3NzTQ0NDTMzMzMNDQ0NMzMzMw0NDQ0zMzMzDQ0NDTMzMzMNDQ0NMzMzMw1NTU1y8vLyzU1NTXLy8vLNTU1NcvLy8s1NTU1y8vLyzU1NTXLy8vLNjY2NsrKyso2NjY2ysrKyjY2NjbKysrKNjY2NsrKyjY2NjY2ysrKyjc3NzfJycnJNzc3N8nJyck3Nzc3ycnJyTc3N8nJyck3Nzc3ycnJyck4ODg4yMjIyDg4ODjIyMjIODg4OMjIyDg4ODg4yMjIyDg4ODjIyMjIOTk5OcfHx8c5OTk5x8fHxzk5OTnHx8fHOTk5OcfHx8c5OTk5x8fHxzo6OjrGxsbGOjo6OsbGxsY6Ojo=";

const PORTION_CODE_TO_LABEL = { "1": "XS", "2": "1-2", "3": "3-4", "4": "5-6" };
const PORTION_COLORS = { "1": "#1565C0", "2": "#43A047", "3": "#5C5EC1", "4": "#EF6C00" };

function portionLabel(code) {
  if (code == null) return "—";
  return PORTION_CODE_TO_LABEL[String(code)] || String(code);
}

function parseMenu(menuStr) {
  if (!menuStr) return [];
  try {
    const parsed = JSON.parse(menuStr);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

const isRice = (n) => n.includes('rice') || n.includes('chawal') || n.includes('khichdi');
// "Tortilla Soup" isn't a roti/bread dish despite containing "tortilla".
const isRoti = (n) => !n.includes('tortilla soup') && (n.includes('roti') || n.includes('naan') || n.includes('tacos') || n.includes('paratha') || n.includes('manda') || n.includes('bread') || n.includes('batura') || n.includes('puri') || n.includes('toast') || n.includes('tortilla') || n.includes('roll') || n.includes('pita') || n.includes('bun') || n.includes('croissant') || n.includes('gakhar') || n.includes('rusk') || n.includes('biscuit') || n.includes('porotta') || n.includes('bagel'));

function wantFlag(raw, userRaw) {
  const val = raw == null || raw === -1 || raw === "-1" ? userRaw : raw;
  return String(val) === "1" ? "Yes" : "No";
}

function parseDishes(dishesStr) {
  if (!dishesStr) return [];
  try {
    const parsed = JSON.parse(dishesStr);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export default function UserRegistrationSearch() {
  const token = localStorage.getItem("access_token");

  const [searchQuery, setSearchQuery] = useState("");
  const [selectedDate, setSelectedDate] = useState(
    () => new Date().toISOString().split("T")[0]
  );
  // idle | loading | notFound | notRegistered | found
  const [searchState, setSearchState] = useState("idle");
  const [foundUser, setFoundUser] = useState(null);
  const [scheduleList, setScheduleList] = useState([]);
  const [filteredSchedule, setFilteredSchedule] = useState([]);
  const [isFromScan, setIsFromScan] = useState(false);

  const [zoneMap, setZoneMap] = useState({});

  useEffect(() => {
    fetch(user_catera + "admin/zone-list", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: token,
      },
    })
      .then((r) => r.json())
      .then((res) => {
        if (res?.status === true && Array.isArray(res.data)) {
          const map = {};
          res.data.forEach((z) => {
            map[String(z.pickup_location_code)] = z.pickup_location_name;
          });
          setZoneMap(map);
        }
      })
      .catch(() => {});
  }, []);

  const searchInputRef = useRef(null);

  // Keep focus on the search box by default so a handheld (keyboard-wedge)
  // scanner can type straight into it without the operator clicking first.
  useEffect(() => {
    searchInputRef.current?.focus();
  }, []);

  // index.html hardcodes <meta name="viewport" content="width=640"> for the
  // whole app, so on a tablet in landscape (real width ~1024px+) the browser
  // scales that fixed 640px layout up to fill the screen, which is what shows
  // up as everything being "zoomed" and needing extra scroll. Portrait mode
  // looked fine as-is, so only override the viewport while in landscape -
  // switch back live on rotation, and always restore the original on unmount.
  useEffect(() => {
    const viewportMeta = document.querySelector('meta[name="viewport"]');
    if (!viewportMeta) return;
    const previousContent = viewportMeta.getAttribute("content");

    const applyForOrientation = (isLandscape) => {
      if (isLandscape) {
        viewportMeta.setAttribute("content", "width=device-width, initial-scale=1.0");
      } else if (previousContent != null) {
        viewportMeta.setAttribute("content", previousContent);
      }
    };

    const mql = window.matchMedia("(orientation: landscape)");
    applyForOrientation(mql.matches);
    const handleChange = (e) => applyForOrientation(e.matches);
    mql.addEventListener("change", handleChange);

    return () => {
      mql.removeEventListener("change", handleChange);
      if (previousContent != null) {
        viewportMeta.setAttribute("content", previousContent);
      }
    };
  }, []);

  // QR scan
  const [scanOpen, setScanOpen] = useState(false);
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const streamRef = useRef(null);
  const scanIntervalRef = useRef(null);
  const isDetectingRef = useRef(false);
  const hasDetectedRef = useRef(false);
  const beepAudioRef = useRef(null);

  const playBeep = () => {
    try {
      if (!beepAudioRef.current) {
        beepAudioRef.current = new window.Audio(SCAN_BEEP_DATA_URI);
      }
      const audio = beepAudioRef.current;
      audio.currentTime = 0;
      // play() returns a promise that can reject (e.g. no interaction yet) -
      // ignore it, this is a nice-to-have and must never block the scan flow.
      audio.play().catch(() => {});
    } catch {}
  };

  // Stop the camera/scan loop if the user navigates away mid-scan, so it
  // can't keep running in the background.
  useEffect(() => {
    return () => {
      if (scanIntervalRef.current) clearInterval(scanIntervalRef.current);
      if (streamRef.current) {
        streamRef.current.getTracks().forEach((t) => t.stop());
      }
      if (beepAudioRef.current) {
        beepAudioRef.current.pause();
      }
    };
  }, []);

  const fetchScheduleForUser = async (userId, date) => {
    const dateParam = date || selectedDate;
    try {
      const regRes = await fetch(
        fmb_schedule_url + `admin/schedule-by-date/${userId}?date=${dateParam}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );
      const regData = await regRes.json();
      const list = regData?.data?.scheduleList;
      if (regData?.status === true && list?.length > 0) {
        setScheduleList(list);
        setFilteredSchedule(list);
        setSearchState("found");
      } else {
        setScheduleList([]);
        setFilteredSchedule([]);
        setSearchState("notRegistered");
      }
    } catch {
      toast.error("Error fetching schedule");
      setSearchState("idle");
    }
  };

  // Re-fetch when date changes if a user is already found
  useEffect(() => {
    if (foundUser && (searchState === "found" || searchState === "notRegistered")) {
      fetchScheduleForUser(foundUser.id, selectedDate);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDate]);

  const handleSearch = async (queryOverride) => {
    const q = (queryOverride !== undefined ? queryOverride : searchQuery).trim();
    if (!q) {
      toast.warning("Please enter an ITS ID, User ID, or Phone Number");
      return;
    }
    setSearchState("loading");
    setFoundUser(null);
    setScheduleList([]);
    setFilteredSchedule([]);
    try {
      const res = await fetch(
        user_management + `admin/search-user?user=${encodeURIComponent(q)}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );
      const data = await res.json();
      const users = data?.data;
      if (!users || users.length === 0) {
        setSearchState("notFound");
        return;
      }
      const user = users[0];
      setFoundUser(user);
      await fetchScheduleForUser(user.id, selectedDate);
    } catch {
      toast.error("Error searching user");
      setSearchState("idle");
    }
  };

  // QR scan using BarcodeDetector
  const startScan = async () => {
    // Guard against re-entrant calls (rapid double-tap on the scan button, or
    // "Scan Next" firing before the previous stream/interval fully tore down) -
    // otherwise the previous camera stream/interval gets orphaned and never stops.
    if (streamRef.current || scanIntervalRef.current) {
      stopScan();
    }
    isDetectingRef.current = false;
    hasDetectedRef.current = false;
    setScanOpen(true);
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: "environment" },
      });
      streamRef.current = stream;
      if (videoRef.current) {
        videoRef.current.srcObject = stream;
        videoRef.current.play();
      }
      if ("BarcodeDetector" in window) {
        const detector = new window.BarcodeDetector({ formats: ["qr_code"] });
        const canvas = canvasRef.current;
        const ctx = canvas?.getContext("2d");
        scanIntervalRef.current = setInterval(async () => {
          // Skip this tick if a detect() from a previous tick is still in
          // flight (can happen on slower devices) or a code was already found.
          if (isDetectingRef.current || hasDetectedRef.current) return;
          const vid = videoRef.current;
          if (vid && vid.readyState === 4) {
            isDetectingRef.current = true;
            canvas.width = vid.videoWidth;
            canvas.height = vid.videoHeight;
            ctx.drawImage(vid, 0, 0);
            try {
              const barcodes = await detector.detect(canvas);
              if (barcodes.length > 0 && !hasDetectedRef.current) {
                hasDetectedRef.current = true;
                const decoded = barcodes[0].rawValue;
                // Close the camera/overlay first so the scan screen never
                // waits on anything else in this handler.
                stopScan();
                playBeep();
                // Don't surface the raw scanned ITS number in the search box
                // or the result banner - just resolve straight to the user's data.
                setIsFromScan(true);
                handleSearch(decoded);
              }
            } catch {}
            isDetectingRef.current = false;
          }
        }, 300);
      } else {
        toast.warning(
          "QR scanning not supported in this browser. Please enter the ID manually."
        );
      }
    } catch {
      toast.error("Camera access denied. Please allow camera access.");
      setScanOpen(false);
    }
  };

  const stopScan = () => {
    if (scanIntervalRef.current) {
      clearInterval(scanIntervalRef.current);
      scanIntervalRef.current = null;
    }
    if (streamRef.current) {
      streamRef.current.getTracks().forEach((t) => t.stop());
      streamRef.current = null;
    }
    setScanOpen(false);
  };

  const clearSearch = () => {
    setSearchQuery("");
    setFoundUser(null);
    setScheduleList([]);
    setFilteredSchedule([]);
    setSearchState("idle");
    setIsFromScan(false);
  };

  const showNotRegisteredForDate = false;
  const displayList = filteredSchedule;

  // Zone is shown once in the user banner (right-aligned next to the name)
  // instead of repeated per schedule card - take the first non-Miqaat entry
  // that actually has a zone, since it's normally the same across a user's
  // entries.
  const bannerZoneLabel = (() => {
    for (const item of displayList) {
      if (item?.schedule_type === "MIQAAT") continue;
      const rawZone = item?.pickup_location_code;
      const effectiveZone = (rawZone == null || String(rawZone) === "-1")
        ? item?.user?.pickup_location_code
        : rawZone;
      if (!effectiveZone || String(effectiveZone) === "-1") continue;
      return zoneMap[String(effectiveZone)] || effectiveZone;
    }
    return null;
  })();

  return (
    <div>
      <Header />
      <div className="side_div_menu" style={{ display: "flex", height: "100%" }}>
        <Sidebarmenu />
        <section className="main_section">
          <div className="custam">
            <div className="main_section2">
              <div className="ExportInventory thali_section Thali_page ur-page-root">
                {/* Title bar */}
                {/* Search + content */}
                <div className="container-fluid">
                  <div className="ur-searchbar">
                  <div style={{ position: "relative", flex: "1 1 260px", minWidth: 140, maxWidth: 520 }}>
                      <input
                        ref={searchInputRef}
                        type="text"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        className="form-control ur-search-input"
                        placeholder="Search by ITS ID, User ID, or Phone Number..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        onKeyDown={async (e) => {
                          if (e.key === "Enter") {
                            // A handheld (keyboard-wedge) scanner types the code then
                            // sends Enter - once the result loads, clear the box and
                            // keep focus so the very next scan can go straight in.
                            setIsFromScan(false);
                            await handleSearch();
                            setSearchQuery("");
                            searchInputRef.current?.focus();
                          }
                        }}
                  />
                {searchQuery && (
                  <button
                    className="ur-clear-btn"
                    onClick={clearSearch}
                    title="Clear"
                  >
                  ×
                  </button>
                )}
              </div>
              <button
                className="btn thali_btn ur-search-btn"
                onClick={() => {
                  searchInputRef.current?.blur();
                  setIsFromScan(false);
                  handleSearch();
                }}
              >
                Search
              </button>
              <button
                className="btn ur-scan-btn"
                onClick={startScan}
                title="Scan QR Code"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="42"
                  height="42"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M3 11V3h8v8H3zm2-2h4V5H5v4zM3 21v-8h8v8H3zm2-2h4v-4H5v4zm8-16h8v8h-8V3zm2 6h4V5h-4v4zm4 4v2h-2v-2h2zm-4 0v2h-2v-2h2zm2 2v2h-2v-2h2zm-2 2v2h-2v-2h2zm2 2v2h-2v-2h2zm2-4v2h-2v-2h2zm0 4v2h-2v-2h2z" />
                </svg>
              </button>
              <div className="thali_btn ur-date-picker-wrap">
                    {/* <div className="Back-page">
                      <h1 className="title_heading">User Registration</h1>
                    </div> */}
                    <input
                      type="date"
                      className="form-control ur-date-picker"
                      value={selectedDate}
                      onChange={(e) => setSelectedDate(e.target.value)}
                    />
                  </div>
            </div>
            {/* ── States ── */}

            {searchState === "idle" && (
              <div className="ur-placeholder">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="80"
                  height="80"
                  viewBox="0 0 24 24"
                  fill="#d8d8d8"
                >
                  <path d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
                </svg>
                <p>Search or scan user to find Thaali registration details</p>
              </div>
            )}

            {searchState === "loading" && (
              <div className="ur-placeholder">
                <img src={loadergif} alt="Loading" style={{ width: 80 }} />
              </div>
            )}

            {searchState === "notFound" && (
              <div className="ur-placeholder">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="80"
                  height="80"
                  viewBox="0 0 24 24"
                  fill="#f0a0a0"
                >
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
                </svg>
                <p style={{ color: "#d15b5b" }}>
                  No user found matching &ldquo;{searchQuery}&rdquo;
                </p>
              </div>
            )}

            {searchState === "notRegistered" && foundUser && (
              <>
                <div className="ur-user-banner">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="22"
                    height="22"
                    viewBox="0 0 24 24"
                    fill="#5C5EC1"
                  >
                    <path d="M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2v-2.4c0-3.2-6.4-4.8-9.6-4.8z" />
                  </svg>
                  <span className="ur-user-name">
                    {foundUser.designation} {foundUser.first_name}{" "}
                    {foundUser.last_name}
                  </span>
                  {/* {!isFromScan && (
                    <span className="ur-user-its">ITS: {foundUser.its_id}</span>
                  )} */}
                </div>
                <div className="ur-placeholder">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="72"
                    height="72"
                    viewBox="0 0 20 26"
                    fill="#d0d0d0"
                  >
                    <path d="M19.5998 10.8148V16.122H0.399902V10.8148H19.5998ZM0.399902 17.3709H19.5998V22.6782L0.399902 22.6784V17.3709ZM3.4768 1.44887C3.4768 0.762038 4.03054 0.200195 4.70745 0.200195H15.292C15.9689 0.200195 16.5227 0.762038 16.5227 1.44887V6.44413H14.6764L14.6768 3.32194C14.6768 2.97851 14.4 2.6976 14.0615 2.6976H5.93837C5.5999 2.6976 5.32304 2.97853 5.32304 3.32194V6.4439H3.47679L3.4768 1.44887ZM13.446 6.4439H6.55354V3.94627H13.4458L13.446 6.4439ZM2.86142 7.6928H17.1383C18.2767 7.6928 19.2305 8.50445 19.5075 9.56609L0.492264 9.56587C0.76935 8.50446 1.72303 7.6928 2.86142 7.6928ZM18.369 25.8002H1.63066C0.953745 25.8002 0.400013 25.2384 0.400013 24.5515V23.9272H19.5999V24.5515C19.5999 25.2381 19.0459 25.8002 18.369 25.8002Z" />
                  </svg>
                  <p>User is not registered for Thaali</p>
                </div>
              </>
            )}

            {searchState === "found" && foundUser && (
              <>
                <div className="ur-user-banner">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="22"
                    height="22"
                    viewBox="0 0 24 24"
                    fill="#5C5EC1"
                  >
                    <path d="M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2v-2.4c0-3.2-6.4-4.8-9.6-4.8z" />
                  </svg>
                  <span className="ur-user-name">
                    {foundUser.designation} {foundUser.first_name}{" "}
                    {foundUser.last_name}
                  </span>
                  {/* {!isFromScan && (
                    <span className="ur-user-its">ITS: {foundUser.its_id}</span>
                  )} */}
                  {bannerZoneLabel && (
                    <span className="ur-zone-name ur-banner-zone">
                      <svg
                        className="ur-zone-icon"
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="#591333"
                      >
                        <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5A2.5 2.5 0 1 1 12 6.5a2.5 2.5 0 0 1 0 5z" />
                      </svg>
                      {bannerZoneLabel}
                    </span>
                  )}
                </div>

                {showNotRegisteredForDate ? (
                  <div className="ur-placeholder">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="72"
                      height="72"
                      viewBox="0 0 24 24"
                      fill="#d0d0d0"
                    >
                      <path d="M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z" />
                    </svg>
                    <p>No registration found for the selected date</p>
                  </div>
                ) : (
                  <div className="Thaali-reg">
                    {displayList.map((item, index) => {
                      const date = convertDateForIos(item.schedule_day);
                      const day = date.toLocaleString("en-US", {
                        weekday: "long",
                      });
                      const month = date.toLocaleString("en-US", {
                        month: "long",
                      });
                      const numericDate = date.getDate();
                      const twoDigitYear = date.getFullYear();
                      const menuItems = parseMenu(item.menu);
                      const dishPortions = parseDishes(item.dishes);
                      const isMiqaat = item.schedule_type === "MIQAAT";
                      const isNiyaaz = item.is_niyaaz === 1 || item.is_niyaaz === "1";
                      const portion = item.portion_type_code == null || item.portion_type_code === "-1"
                        ? item.user?.portion_type_code
                        : item.portion_type_code;

                      return (
                        <div
                          key={index}
                          className={`card ${
                            isMiqaat || isNiyaaz ? "Thaali-myBg" : ""
                          }`}
                          style={isMiqaat ? { background: "#D3E3FD" } : {}}
                        >
                          <div className="ur-date-menu-group">
                          <div className="Calendar_card spacemargin">
                            <h6>{day}</h6>
                            <h1>{numericDate}</h1>
                            <p>
                              {month}, {twoDigitYear}
                            </p>
                            <p className="hijri_date">
                              <span className="hijri_day">
                                {getHijriParts(date).day}
                              </span>
                              <span className="hijri_month">
                                {getHijriParts(date).month}
                              </span>
                            </p>
                          </div>

                          <div className="reg-menu-div " style={{ maxWidth: 860, minWidth: 310 }}>
                            {isNiyaaz && (
                              <div className="thali-checkbox">
                                <h5 className="miqaat-thaali-heding">
                                  MIQAAT-THAALI
                                </h5>
                              </div>
                            )}
                            {isMiqaat && (
                              <div className="thali-checkbox">
                                <h5 className="miqaat-jaman-thaali-heding">
                                  MIQAAT
                                </h5>
                              </div>
                            )}
                            {/* <h5 className="thalireg_menu_list">Menu:</h5> */}
                            <ul className="thalireg_menu_list">
                              {(() => {
                                const main = [];
                                const riceRoti = [];
                                menuItems.forEach((dish, i) => {
                                  const n = dish.toLowerCase();
                                  (isRice(n) || isRoti(n) ? riceRoti : main).push({ dish, i });
                                });
                                const renderDishRow = ({ dish, i }) => {
                                  const n = dish.toLowerCase();
                                  const badgeStyle = { whiteSpace: "nowrap" };
                                  let badge;
                                  if (isRice(n)) {
                                    const skippable = item.allow_skip_rice === "1";
                                    const val = wantFlag(item.want_rice, item.user?.want_rice);
                                    if (!skippable || val === "Yes") {
                                      const color = PORTION_COLORS[String(portion)] || "#5C5EC1";
                                      badge = <span className="ur-portion-badge" style={{ ...badgeStyle, background: color }}>{portionLabel(portion)}</span>;
                                    } else {
                                      badge = <span className="ur-portion-badge" style={{ ...badgeStyle, background: "#C62828" }}>No</span>;
                                    }
                                  } else if (isRoti(n)) {
                                    const skippable = item.allow_skip_roti === "1";
                                    const val = wantFlag(item.want_roti, item.user?.want_roti);
                                    if (!skippable || val === "Yes") {
                                      const color = PORTION_COLORS[String(portion)] || "#5C5EC1";
                                      badge = <span className="ur-portion-badge" style={{ ...badgeStyle, background: color }}>{portionLabel(portion)}</span>;
                                    } else {
                                      badge = <span className="ur-portion-badge" style={{ ...badgeStyle, background: "#C62828" }}>No</span>;
                                    }
                                  } else {
                                    const dishMatch = dishPortions.find(
                                      d => d.dish_name?.toLowerCase().trim() === dish.toLowerCase().trim()
                                    );
                                    const dishCode = dishMatch?.portion_type_code;
                                    const effectiveCode = dishCode != null ? dishCode : portion;
                                    const color = PORTION_COLORS[String(effectiveCode)] || "#5C5EC1";
                                    badge = <span className="ur-portion-badge" style={{ ...badgeStyle, background: color }}>{portionLabel(effectiveCode)}</span>;
                                  }
                                  return (
                                    <li key={i} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 28 }}>
                                      <span className="ur-dish-name">{dish}</span>
                                      {badge}
                                    </li>
                                  );
                                };
                                return (
                                  <>
                                    {main.map(renderDishRow)}
                                    {riceRoti.length > 0 && (
                                      <>
                                        <li style={{ listStyle: "none", borderTop: "1px dashed #d0d0d0", margin: "6px 0" }} />
                                        {riceRoti.map(renderDishRow)}
                                      </>
                                    )}
                                  </>
                                );
                              })()}
                              {item.fateha_name && (
                                <>
                                  <h5 className="thali-heding">Fateha Name</h5>
                                  <li>{item.fateha_name}</li>
                                </>
                              )}
                            </ul>
                          </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </>
            )}
                </div>{/* container-fluid (search+content) */}

            {foundUser && (
              <div className="ur-action-bar">
                <button
                  className="ur-done-btn"
                  onClick={() => {
                    clearSearch();
                    searchInputRef.current?.focus();
                  }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
                  </svg>
                  Done
                </button>
                <button className="ur-scan-next-btn" onClick={() => { clearSearch(); startScan(); }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M3 11V3h8v8H3zm2-2h4V5H5v4zM3 21v-8h8v8H3zm2-2h4v-4H5v4zm8-16h8v8h-8V3zm2 6h4V5h-4v4zm4 4v2h-2v-2h2zm-4 0v2h-2v-2h2zm2 2v2h-2v-2h2zm-2 2v2h-2v-2h2zm2 2v2h-2v-2h2zm2-4v2h-2v-2h2zm0 4v2h-2v-2h2z"/>
                  </svg>
                  Scan Next
                </button>
                {/* <button
                  className="ur-handheld-scan-btn"
                  onClick={() => {
                    clearSearch();
                    searchInputRef.current?.focus();
                  }}
                  title="Prepare for the next handheld scanner scan"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                    <rect x="2" y="4" width="2" height="16" />
                    <rect x="6" y="4" width="1" height="16" />
                    <rect x="9" y="4" width="3" height="16" />
                    <rect x="14" y="4" width="1" height="16" />
                    <rect x="17" y="4" width="2" height="16" />
                    <rect x="21" y="4" width="1" height="16" />
                  </svg>
                  Scan Next
                </button> */}
              </div>
            )}
              </div>{/* ExportInventory */}
            </div>{/* main_section2 */}
          </div>{/* custam */}
        </section>
      </div>{/* side_div_menu */}

      {/* QR Scan Overlay */}
      {scanOpen && (
        <div className="ur-scan-overlay">
          <div className="ur-scan-modal">
            <h5>Scan QR Code</h5>
            <p>Point camera at the user&apos;s QR code</p>
            <div className="ur-scan-viewfinder">
              <video
                ref={videoRef}
                style={{ width: "100%", borderRadius: 8, background: "#000" }}
                muted
                playsInline
              />
              <canvas ref={canvasRef} style={{ display: "none" }} />
              <div className="ur-scan-corners" />
            </div>
            <button className="btn thali_btn" style={{ marginTop: 16 }} onClick={stopScan}>
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
